// Lib
import React from 'react';
import { debounce } from 'lodash';

export default (DecoratedComponent) => {
    class androidKeyboardStateDecorator extends React.Component {
        constructor(props) {
            super(props);
            this.state = { keyboardVisible: false };
        }

        componentWillMount() {
            window.addEventListener('resize', this.debouncedOnResize);
            this.initialWindowHeight = window.innerHeight;
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.debouncedOnResize);
        }

        onResize = (event) => {
            this.setState({ keyboardVisible: window.innerHeight < this.initialWindowHeight });
        };

        debouncedOnResize = debounce(this.onResize, 10);

        render() {
            const { keyboardVisible } = this.state;
            return <DecoratedComponent keyboardVisible={keyboardVisible} {...this.props} />;
        }
    }

    androidKeyboardStateDecorator.propTypes = {};

    return androidKeyboardStateDecorator;
};
